import React, { useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../../services/api';
import PublicSEO from '../../components/public/PublicSEO';
import { Heading, PageContainer } from '../../components/ui';
import { publicPath } from '../../utils/canonicalUrl';
import { buildBreadcrumb } from '../../utils/jsonLd';
import './ContentGuide.css';
import './StrutturePage.css';

export default function StrutturePage() {
  const [hits, setHits] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/public/search', { params: { sort: 'disponibilita', raggioKm: 200 } })
      .then((res) => setHits(Array.isArray(res.data?.results) ? res.data.results : []))
      .catch(() => setHits([]))
      .finally(() => setLoading(false));
  }, []);

  const strutture = useMemo(() => {
    const map = new Map();
    hits.forEach((h) => {
      if (!h.idStruttura || !h.strutturaNome) return;
      const cur = map.get(h.idStruttura) || {
        id: h.idStruttura,
        nome: h.strutturaNome,
        citta: h.sedeCitta || '',
        branche: new Set(),
      };
      if (h.brancaNome) cur.branche.add(h.brancaNome);
      if (h.sedeCitta) cur.citta = h.sedeCitta;
      map.set(h.idStruttura, cur);
    });
    return Array.from(map.values())
      .map((s) => ({ ...s, branche: Array.from(s.branche).slice(0, 4) }))
      .sort((a, b) => a.nome.localeCompare(b.nome, 'it'));
  }, [hits]);

  return (
    <div className="vc-strutture">
      <PublicSEO
        title="Strutture su Virtual Clinic"
        description="Strutture e poliambulatori con disponibilità pubblicate su Virtual Clinic. Cerca visite ed esami per sede e specialità."
        canonicalPath="/strutture"
        jsonLd={[
          buildBreadcrumb([
            { name: 'Home', path: '/' },
            { name: 'Strutture' },
          ]),
        ]}
      />
      <PageContainer>
        <Heading level={1}>Strutture</Heading>
        <p className="vc-strutture__lead">
          Sedi con almeno una disponibilità pubblica. Per filtrare per prestazione usa la ricerca.
        </p>

        {loading && <p>Caricamento…</p>}
        {!loading && strutture.length === 0 && (
          <p>
            Al momento non ci sono strutture con slot pubblicati.{' '}
            <Link to={publicPath('/ricerca')}>Cerca disponibilità</Link>
          </p>
        )}
        {!loading && strutture.length > 0 && (
          <ul className="vc-strutture__list">
            {strutture.map((s) => (
              <li key={s.id} className="vc-strutture__card">
                <h2 className="vc-strutture__name">{s.nome}</h2>
                {s.citta ? <p className="vc-strutture__meta">{s.citta}</p> : null}
                {s.branche.length > 0 && (
                  <p className="vc-strutture__meta">{s.branche.join(' · ')}</p>
                )}
                <Link
                  to={`${publicPath('/ricerca')}?struttura=${encodeURIComponent(s.nome)}`}
                  className="vc-btn vc-btn-primary vc-btn-sm"
                >
                  Vedi disponibilità
                </Link>
              </li>
            ))}
          </ul>
        )}

        <div className="vc-strutture__cta">
          <Link to={publicPath('/ricerca')} className="vc-btn vc-btn-outline">
            Cerca visite ed esami
          </Link>
          <Link to={publicPath('/per-le-strutture')} className="vc-btn vc-btn-outline">
            Sei una struttura?
          </Link>
        </div>
      </PageContainer>
    </div>
  );
}
